import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1302PersonLoeschenStatus: 'idle',
    startProcess1302PersonLoeschenError: undefined as any,
    loadUserParamsProcess1302PersonLoeschenStatus: 'idle',
    loadUserParamsProcess1302PersonLoeschenError: undefined as any,

    process1302PersonLoeschenList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1302PersonLoeschen = createAsyncThunk('process1302PersonLoeschenSlice/startProcess1302PersonLoeschen', async ({ process1302PersonLoeschen }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1302PersonLoeschen/`,
        prepareData(process1302PersonLoeschen),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1302PersonLoeschenStatus } = getState().process1302PersonLoeschenSlice
        return startProcess1302PersonLoeschenStatus !== 'pending'
    }
})

export const loadUserParamsProcess1302PersonLoeschen = createAsyncThunk('process1302PersonLoeschenSlice/loadUserParamsProcess1302PersonLoeschen', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1302PersonLoeschen/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1302PersonLoeschenStatus } = getState().process1302PersonLoeschenSlice
        return loadUserParamsProcess1302PersonLoeschenStatus !== 'pending'
    }
})

const Process1302PersonLoeschenSlice = createSlice({
    name: 'process1302PersonLoeschenSlice',
    initialState,
    reducers: {
        resetstartProcess1302PersonLoeschen: (state) => {
            state.job = undefined
            state.startProcess1302PersonLoeschenError = undefined
        },
        resetstartProcess1302PersonLoeschenError: (state) => {
            state.startProcess1302PersonLoeschenError = undefined
        },
        resetloadUserParamsProcess1302PersonLoeschen: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1302PersonLoeschenError = undefined
        },
        resetloadUserParamsProcess1302PersonLoeschenError: (state) => {
            state.loadUserParamsProcess1302PersonLoeschenError = undefined
        },
        removeFromProcess1302PersonLoeschenListById: (state, action) => {
            state.process1302PersonLoeschenList = state.process1302PersonLoeschenList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1302PersonLoeschenListByIds: (state, action) => {
            state.process1302PersonLoeschenList = state.process1302PersonLoeschenList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1302PersonLoeschenList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1302PersonLoeschenStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1302PersonLoeschenList = []
            state.startProcess1302PersonLoeschenStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1302PersonLoeschen.pending, (state) => {
            state.startProcess1302PersonLoeschenStatus = 'pending'
            state.startProcess1302PersonLoeschenError = undefined
        })
        builder.addCase(startProcess1302PersonLoeschen.fulfilled, (state, action) => {
            state.startProcess1302PersonLoeschenStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1302PersonLoeschen.rejected, (state, action) => {
            state.startProcess1302PersonLoeschenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1302PersonLoeschenError = action.error.message
            } else {
                state.startProcess1302PersonLoeschenError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1302PersonLoeschen.pending, (state) => {
            state.loadUserParamsProcess1302PersonLoeschenStatus = 'pending'
            state.loadUserParamsProcess1302PersonLoeschenError = undefined
        })
        builder.addCase(loadUserParamsProcess1302PersonLoeschen.fulfilled, (state, action) => {
            state.loadUserParamsProcess1302PersonLoeschenStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1302PersonLoeschen.rejected, (state, action) => {
            state.loadUserParamsProcess1302PersonLoeschenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1302PersonLoeschenError = action.error.message
            } else {
                state.loadUserParamsProcess1302PersonLoeschenError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1302PersonLoeschen,
    resetstartProcess1302PersonLoeschenError,
    resetloadUserParamsProcess1302PersonLoeschen,
    resetloadUserParamsProcess1302PersonLoeschenError,
    removeFromProcess1302PersonLoeschenListById,
    removeFromProcess1302PersonLoeschenListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1302PersonLoeschenSlice.actions
export default Process1302PersonLoeschenSlice.reducer
